import { z } from "zod";

const UpdateBrandStatusSchema = z.object({
  brandId: z.number().int().positive(),
  brandIsActive: z.boolean(),
});

export type UpdateBrandStatusDTOShape = z.infer<typeof UpdateBrandStatusSchema>;

export class UpdateBrandStatusDTO {
  readonly brandId!: number;
  readonly brandIsActive!: boolean;

  constructor(data: UpdateBrandStatusDTOShape) {
    const validated = UpdateBrandStatusSchema.parse(data);
    Object.assign(this, validated);
  }

  static validate(data: unknown) {
    return UpdateBrandStatusSchema.safeParse(data);
  }
}
